// extracted by mini-css-extract-plugin
export default {"addReview":"AddReviewComponent_addReview__Yhoc0","comments":"AddReviewComponent_comments__BBl1P","reviewInput":"AddReviewComponent_reviewInput__04ORx"};